import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import * as Yup from "yup";
import { useLocation } from "react-router";
import axios from "helpers/API";
import { errorBackendMsg } from "helpers/helpers";
import { Alert } from "@material-ui/lab";
import { AlertTitle } from "@material-ui/lab";
import { Link, useHistory } from "react-router-dom";
import logo from "./assets/logo-avellaneda.png";
import { useFormik } from "formik";


function useQuery() {
  return new URLSearchParams(useLocation().search); 
}

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#232323",
    minWidth: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  card: {
    backgroundColor: theme.palette.secondary.main,
  },
  cardContent: {
    backgroundColor: "#fff",
  },
}));

function ForgotPassword() {
  const classes = useStyles();
  const [error, setError] = useState(false);
  const [msg, setMsg] = useState(null);
  const [exito, setExito] = useState(null);
  const [msgExito, setMsgExito] = useState(null);

  useEffect(() => {
    document.title = "Recuperar Contraseña";
  }, []);

  
  //APIMENSAJE

  const resetPassword = (consulta) => {
    setError(false);
    axios
      .post("/seguridad/usuarios/password/olvide", consulta)
      .then(function (response) {
        if (response.data.error) {
          setError(true);
          setMsg(response.data.msg);
        } else {
          setExito(true);
          setMsgExito(response.data.msg);
        }
      })
      .catch(function (error) {
        setError(true);
        setMsg(error);
      });
  };

  const formik = useFormik({
    initialValues: {
      username: "",
      email: "",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log(JSON.stringify(values, null, 2));
      resetPassword(values);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Card className={classes.card}>
        <img style={{ padding: 20 }} src={logo} />
        <CardContent className={classes.cardContent}>
          <Typography variant="h6">Recuperar contraseña</Typography>
          Ingrese su usuario y el email
          <br /> registrado para recibir la nueva <br />
          contraseña de acceso
          {error && (
            <Box mb={2} mt={2}>
              <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                {msg}
              </Alert>
            </Box>
          )}
          {exito && (
            <Box mb={2} mt={2}>
              <Alert severity="success">
                <AlertTitle>Recuperar contraseña</AlertTitle>
                {msgExito}
              </Alert>
            </Box>
          )}
          <Box>
            <TextField
              fullWidth
              label="Usuario"
              type="text"
              id="username"
              name="username"
              value={formik.values.username}
              onChange={formik.handleChange}
              error={formik.touched.username && Boolean(formik.errors.username)}
              helperText={formik.touched.username && formik.errors.username}
            />
          </Box>
          <Box mt={1}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              id="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              
            />
          </Box>
          {exito && (
            <Box mt={3}>
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                onClick={() => window.location.reload()}
              >
                Volver a Iniciar Sesión
              </Button>
            </Box>
          )}
          <Box mt={3}>
            <Button
              disabled={exito}
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
            >
              Confimar
            </Button>
          </Box>
        </CardContent>
      </Card>
    </form>
    // <Container
    //   className="d-flex justify-content-center align-items-center"
    //   fluid
    //   style={{ height: "100vh", backgroundColor: "#83c442" }}
    // >
    //   <br />
    //   <Row className="login-width m-auto align-items-center">
    //     <Col xs={12} className="ml-0 pl-0">
    //       <Card>
    //         <Card.Body>
    //           <Row>
    //             <Col xs={12}>
    //               <h4>Recuperar contraseña</h4>
    //               <p>
    //                 Ingrese su usuario y el email registrado para recibir la
    //                 nueva contraseña de acceso
    //               </p>
    //             </Col>
    //           </Row>
    //           <hr />
    //           <br />
    //           <Row>
    //             <Col xs={12}>
    //               <Formik
    //                 enableReinitialize={true}
    //                 initialValues={{
    //                   username: query.get("username")
    //                     ? query.get("username")
    //                     : userData
    //                     ? userData.username
    //                     : "",
    //                   email: query.get("email")
    //                     ? query.get("email")
    //                     : userData
    //                     ? userData.email
    //                     : "",
    //                 }}
    //                 validationSchema={Yup.object({
    //                   username: Yup.string().trim().required("Campo requerido"),
    //                   email: Yup.string()
    //                     .email("Email no válido")
    //                     .required("Campo requerido"),
    //                 })}
    //                 validateOnChange={false}
    //                 validateOnBlur={true}
    //                 onSubmit={(values, { setSubmitting }) => {
    //                   resetPassword(values);
    //                   console.log(values);
    //                   setSubmitting(false);
    //                 }}
    //                 onReset={() => {
    //                   // to do
    //                 }}
    //               >
    //                 {(formik) => (
    //                   <Form
    //                     onSubmit={formik.handleSubmit}
    //                     onReset={formik.handleReset}
    //                   >
    //                     <Row className="justify-content-center">
    //                       <APIMensaje
    //                         isError={isError}
    //                         msg={msg}
    //                         mostrarMensaje={mostrarMensaje}
    //                         onClose={() => setMostrarMensaje(false)}
    //                       />
    //                     </Row>
    //                     <Row>
    //                       <Col xs={12}>
    //                         <TextInput
    //                           colInput={12}
    //                           label="Username"
    //                           required={true}
    //                           name="username"
    //                           type="text"
    //                         />
    //                       </Col>
    //                       <Col xs={12}>
    //                         <TextInput
    //                           colInput={12}
    //                           label="E-Mail"
    //                           required={true}
    //                           name="email"
    //                           type="text"
    //                         />
    //                       </Col>
    //                     </Row>
    //                     <br />
    //                     <br />
    //                     <Row className="justify-content-end mr-2">
    //                       <Button
    //                         onClick={() => history.push("/login")}
    //                         className="mr-2"
    //                         variant="secondary"
    //                       >
    //                         Volver
    //                       </Button>
    //                       <Button disabled={btnConfirmarEstaDeshabilitado} variant="primary" type="submit">
    //                         Confimar
    //                       </Button>
    //                     </Row>
    //                   </Form>
    //                 )}
    //               </Formik>
    //             </Col>
    //           </Row>
    //           <br />
    //         </Card.Body>
    //       </Card>
    //     </Col>
    //   </Row>
    // </Container>
  );
}

export default ForgotPassword;
